import { render, staticRenderFns } from "./select-month.vue?vue&type=template&id=dd4e73a0"
import script from "./select-month.vue?vue&type=script&lang=js"
export * from "./select-month.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports